import React from 'react';
import styled from 'styled-components';
import { Box, IconButton } from '@miro-site/core';
import theme from './theme';

/* Social buttons */
import { Twitter, Facebook, LinkedIn, Instagram, Youtube } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
var icons = {
  Twitter: /*#__PURE__*/_jsx(Twitter, {}),
  Facebook: /*#__PURE__*/_jsx(Facebook, {}),
  LinkedIn: /*#__PURE__*/_jsx(LinkedIn, {}),
  Instagram: /*#__PURE__*/_jsx(Instagram, {}),
  Youtube: /*#__PURE__*/_jsx(Youtube, {})
};
var Social = styled(Box).attrs({
  as: 'ul',
  $styles: {
    display: 'flex',
    justifyContent: ['center', 'center', '', '', '']
  },
  $mt: theme.footer.social.margin.top,
  $mb: theme.footer.social.margin.bottom
}).withConfig({
  displayName: "FooterSocial__Social",
  componentId: "sc-l0iz85-0"
})([""]);
var SocialItem = styled(Box).attrs({
  as: 'li',
  $ml: theme.footer.socialItem.margin.left
}).withConfig({
  displayName: "FooterSocial__SocialItem",
  componentId: "sc-l0iz85-1"
})(["&:first-child{margin-left:0;}"]);
var IconLink = styled(IconButton).withConfig({
  displayName: "FooterSocial__IconLink",
  componentId: "sc-l0iz85-2"
})(["path{", "}&:hover path{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    fill: 'var(--wcds-footer-icon-color)',
    transition: "fill ease ".concat(theme.animation.transitionDuration)
  });
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    fill: 'var(--wcds-footer-icon-active-color)'
  });
});

var FooterSocial = function FooterSocial(props) {
  var items = props.items;
  return /*#__PURE__*/_jsx(Social, {
    children: items.map(function (item, index) {
      return /*#__PURE__*/_jsx(SocialItem, {
        children: /*#__PURE__*/_jsx(IconLink, {
          icon: icons[item.title],
          label: item.title,
          href: item.path,
          title: item.title
        })
      }, index);
    })
  });
};

export default FooterSocial;